// Billing Reconciliation UI defaults. Keep sample dealer data synthetic or
// mock-only; production runs load source rows from the billing API.

// Fallback identity for mock/degraded auth states.
export const CURRENT_USER = {
  name: 'Unknown reviewer',
  email: '',
  initials: 'UR',
};

export const PROGRAMS = [
  { id: 'website', label: 'Website' },
  { id: 'chat', label: 'Chat' },
  { id: 'trade', label: 'Trade' },
];
export const ENABLED_BILLING_RECONCILIATION_PROGRAMS = ['website', 'chat', 'trade'];

export const SERVICE_MONTHS = [
  { id: '2026-04-01', label: 'April 2026' },
  { id: '2026-03-01', label: 'March 2026' },
  { id: '2026-02-01', label: 'February 2026' },
  { id: '2026-01-01', label: 'January 2026' },
];

// Shared status config — one source of truth for:
//   label           display name
//   defaultOpen     whether the group is expanded by default in panels
//   billing         counts toward current-cycle MRR total
//   border          row-level left-border accent color
//   chipSx          inline sx so chips match the border palette
export const PRODUCT_STATUS_CONFIG = {
  LIVE: {
    label: 'Live',
    defaultOpen: true,
    billing: true,
    border: '#2e7d32',
    chipSx: { bgcolor: '#2e7d32', color: '#fff', fontWeight: 600 },
  },
  'PENDING LIVE': {
    label: 'Pending live',
    defaultOpen: false,
    billing: false,
    border: '#f9a825',
    chipSx: { bgcolor: '#f9a825', color: '#000', fontWeight: 600 },
  },
  'PENDING CANCEL': {
    label: 'Pending cancel',
    defaultOpen: true,
    billing: true,
    border: '#ed6c02',
    chipSx: { bgcolor: '#ed6c02', color: '#fff', fontWeight: 600 },
  },
  CANCELLED: {
    label: 'Cancelled',
    defaultOpen: false,
    billing: false,
    border: '#c62828',
    chipSx: { bgcolor: '#c62828', color: '#fff', fontWeight: 600 },
  },
};
export const PRODUCT_STATUS_ORDER = ['LIVE', 'PENDING CANCEL', 'PENDING LIVE', 'CANCELLED'];

export const normalizeProductStatus = (value, fallback = 'CANCELLED') => {
  const raw = String(value || '').trim().toUpperCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ');
  if (raw === 'LIVE') return 'LIVE';
  if (raw === 'PENDING LIVE') return 'PENDING LIVE';
  if (raw === 'PENDING CANCEL') return 'PENDING CANCEL';
  if (raw === 'CANCELLED' || raw === 'CANCELED') return 'CANCELLED';
  return fallback;
};

// ---- Seeded autocomplete suggestions ---------------------------------------
// Initial list surfaced in the variance category / remediation combo boxes.
// As user adds new ones they'll be appended in localStorage.
export const DEFAULT_VARIANCE_CATEGORIES = [
  'Pricing mismatch',
  'Product code drift',
  'Cancellation timing',
  'Brand secondary mismatch',
  'Missing in CPQ',
  'Missing in GM',
  'DPE stale data',
  'Credit not applied',
  'Duplicate entry',
  'Package tier change',
];

export const DEFAULT_REMEDIATION_STEPS = [
  'Updated CPQ subscription price',
  'Submitted GM adjustment ticket',
  'Refreshed DPE program cache',
  'Cancelled duplicate in CPQ',
  'Added missing product to CPQ',
  'Confirmed with billing team',
  'Escalated to account manager',
  'No action needed (within tolerance)',
];
